module.exports = __webpack_public_path__ + "img/eagle.2e8343eb.png";